import { comparisonType, ComponentType, ICondition, IDashboard, IGripPosition } from "./types";
import { cloneObject, getFloatValue, getUID } from "../../system/utils";
import { CSSProperties } from "react";
import { DashboardModuleType } from "../interruptions/types";
import { getPaletteColor } from "../../configuration/configuration";
import { IRealtimeData } from "../../types";

const mockLayout: IDashboard = {
  dashboardID: null,
  name: "New Layout",
  moduleID: 0,
  nodeID: 0,
  nodeType: "",
  userID: 0,
  owner: null,
  isPrivate: true,
  isDefault: false,
  isAcquisition: true,
  isEditable: false,
  customConfig: {
    range: 1,
    fontSize: 1,
    scan: 1000
  },
  layout: {
    components : [],
    palette: {}
  },
  rtModule: true
};

export const getEmptyDashboard = (): IDashboard => {
  return cloneObject(mockLayout);
};

export const getGripLocation = (component: IGripPosition): CSSProperties => {

  return {
    gridRow: `${component.row}/span ${component.rowSpan}`,
    gridColumn: `${component.column}/span ${component.columnSpan}`
  };
};


export const getComponentConfig = (componentType: ComponentType): any => {
  if (componentType === ComponentType.Events) {
    return {
      variables: []
    };
  }

  if (componentType === ComponentType.AcquisitionChart) {
    return {
      acquisitionCell: {
        key: getUID(),
        module: DashboardModuleType.Acquisition,
        title: "Name",
        machine: null,
        variables: [],
        events: []
      }
    };
  }

  if (componentType === ComponentType.Indicators) {
    return {
      variables: [{
        hash: getUID(),
        machine: "",
        code: "",
        title: "",
        color: getPaletteColor(),
        unit: "",
        minimum: 0,
        maximum: 100,
        decimals: 0
      }]
    };
  }

  if (componentType === ComponentType.Doughnut) {
    return {
      variables: []
    };
  }

  if (componentType === ComponentType.Gauge) {
    return {
      variables: [{
        hash: getUID(),
        machine: "",
        code: "",
        title: "",
        color: getPaletteColor(),
        unit: "",
        minimum: 0,
        maximum: 100,
        decimals: 0,
        segments: []
      }]
    };
  }

  if (componentType === ComponentType.Radar) {
    return {
      variables: []
    };
  }

  if (componentType === ComponentType.Custom) {
    return {
      code: ""
    };
  }

  return {};
};

const evaluate = (a: number, b: number, comparison: comparisonType): boolean => {
  return comparison === "=" && a === b
    || comparison === "<" && a < b
    || comparison === ">" && a > b
    || comparison === ">=" && a >= b
    || comparison === "<=" && a <= b
    || comparison === "<>" && a !== b;
};

export const getStatusClass = (status: string | null): string =>  {
  return !status ? "" : `${status}-status`;
};

export const getConditionResult = (value: number, conditions: ICondition[], realtime: Record<string, IRealtimeData>): ICondition | null =>  {
  for (const condition of conditions) {
    if (condition.type === "VALUE") {
      if (condition.severity !== "none" && evaluate(value, condition.value as number, condition.comparison)) {
        return condition;
      }
    } else if (realtime[condition.value]) {
      if (condition.severity !== "none" && evaluate(value, getFloatValue(realtime[condition.value], 0), condition.comparison)){
        return condition;
      }
    }
  }

  return null;
};

